import PropTypes from 'prop-types';

import { Abstrap } from '../../..';

const propTypes = { ...Abstrap.propTypes, status: PropTypes.oneOf(['standard', 'valid', 'error']).isRequired };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    status: 'standard',
};

class FormInfo extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            status,
        } = this.props;
        return [
            'c-form__info',
            status === 'valid' ? 'c-form__info_valide' : false,
            status === 'error' ? 'c-form__info_error' : false,
            className,
        ];
    }

}

FormInfo.propTypes = propTypes;

FormInfo.defaultProps = defaultProps;

export default FormInfo;
